import { ensureState } from 'redux-optimistic-ui';

export const competitions = s => ensureState(s).competitions;
